module.exports = __webpack_public_path__ + "static/media/SLOTS@3x.41e21deb.png";